import { makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import AIInsightsData from 'modules/enps/store/models/AIInsights'

class AIInsights extends Collection<AIInsightsData> {
  constructor(attrs = []) {
    super(attrs)
    makeObservable(this, {})
  }

  get cacheKey(): string {
    return 'aiInsights'
  }

  model() {
    return AIInsightsData
  }
}

const aiInsights: AIInsights = new AIInsights()

export default aiInsights
